import React, { useCallback } from 'react'
import { Box, Typography, Grid } from '@material-ui/core'

import { PageTitle } from 'Components/PageTitle'

import D2DEmptyState from '../../../../Assets/Images/icons/d2dEmptyState'
import { CAMPAING_TYPE_PARAM_TO_EMPTY_TITLE } from '../../../../shared/constants'

import { EmptyStateSimpleBtn } from '../CampaignEmptyStateButtons'
import EmptyStateMessage from '../EmptyStateMessage'
import usePosthogAnalyticsD2D from './hooks/usePosthogAnalyticsD2D'

const CampaignEmptyStateD2D = ({
  classes,
  isSelfServeEnabled,
  handleCreateCampaign,
  validRoute,
  enabledChannel,
  route,
}) => {
  const { emitAnalyticsEvent } = usePosthogAnalyticsD2D()

  const handleClick = useCallback(async () => {
    await handleCreateCampaign()
    emitAnalyticsEvent()
  }, [handleCreateCampaign])

  return (
    <React.Fragment>
      {!enabledChannel && (
        <EmptyStateMessage title="Sorry, this channel is currently not available to create a campaign in your country." />
      )}
      <Box className={classes.campaignWrapper}>
        <PageTitle className={classes.title}>
          {CAMPAING_TYPE_PARAM_TO_EMPTY_TITLE[route]}
        </PageTitle>
        <Grid
          container
          spacing={3}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} sm={7}>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <p className={classes.emptyStateText}>
                Door-to-door or door hanger campaigns offer a really successful
                channel for advertisers aiming to target geographically areas
                based on demographics. This channel allows for precise
                targeting.
              </p>
              <p className={classes.emptyStateText}>
                Use our campaign builder to select your preferred areas. To
                assist you in identifying the most advantageous areas, we
                provide geographic-based demographics.
              </p>
              <p className={classes.emptyStateText}>
                Exploring this channel doesn't require a large investment; you
                can experiment and gain insights for under three digits!
              </p>
            </Box>
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
              <p className={classes.emptyStateText}>
                Design a door-to-door flyer distribution campaign using our
                geographic-based demographics to select your preferred areas. No
                large investment is required—experiment and gain insights for
                under 3-figures.
              </p>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} className="text-center">
            <D2DEmptyState />
          </Grid>
        </Grid>
        {validRoute && enabledChannel && (
          <Box className={classes.btnWrapper}>
            <Typography className={classes.btnTitle}>
              {isSelfServeEnabled
                ? "Let's create your first campaign!"
                : 'Once you have a campaign, you’ll be able to see it here'}
            </Typography>
            {isSelfServeEnabled && (
              <EmptyStateSimpleBtn classes={classes} onClick={handleClick} />
            )}
          </Box>
        )}
      </Box>
    </React.Fragment>
  )
}

export default CampaignEmptyStateD2D
